/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EmergencyKitUsageDtoResponse } from '../models/EmergencyKitUsageDtoResponse';
import type { MarkEmergencyDrugUsedCommand } from '../models/MarkEmergencyDrugUsedCommand';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class EmergencyKitService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param requestBody
     * @returns EmergencyKitUsageDtoResponse Success
     * @throws ApiError
     */
    public postApiEmergencyKitMarkUsed(
        requestBody?: MarkEmergencyDrugUsedCommand,
    ): CancelablePromise<EmergencyKitUsageDtoResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/EmergencyKit/MarkUsed',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Server Error`,
            },
        });
    }
}
